import { cn } from "@/utils/cn";
import { memo } from "react";

interface FavouritesOutlineIconProps {
  className?: string;
}

export const FavouritesOutlineIcon = memo(function FavouritesOutlineIcon({
  className,
}: FavouritesOutlineIconProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className={cn("fill-current", className)}
    >
      <path d="M17 3H6.5C6.10218 3 5.72064 3.15804 5.43934 3.43934C5.15804 3.72064 5 4.10218 5 4.5V21C5.00007 21.1338 5.03595 21.2652 5.10393 21.3805C5.17191 21.4958 5.2695 21.5908 5.38659 21.6557C5.50367 21.7206 5.63598 21.7529 5.76978 21.7494C5.90358 21.7458 6.034 21.7066 6.1475 21.6356L11.75 18.1341L17.3534 21.6356C17.4669 21.7063 17.5972 21.7454 17.7309 21.7488C17.8646 21.7522 17.9967 21.7198 18.1136 21.655C18.2306 21.5902 18.3281 21.4953 18.396 21.3801C18.4639 21.2649 18.4998 21.1337 18.5 21V4.5C18.5 4.10218 18.342 3.72064 18.0607 3.43934C17.7794 3.15804 17.3978 3 17 3ZM17 19.6472L12.1466 16.6144C12.0274 16.5399 11.8896 16.5004 11.7491 16.5004C11.6085 16.5004 11.4708 16.5399 11.3516 16.6144L6.5 19.6472V4.5H17V19.6472Z" />
    </svg>
  );
});
